import React, { useEffect, useState } from 'react';

import { CoverType } from '../ImageList/types';
import Preview from './components/Preview';
import Sidebar from './components/Sidebar';
import SidebarOverlay from './components/SidebarOverlay';
import { DesignContextProvider } from './context/Design';
import { DesignCard } from './enums';
import { DesignComposition, DesignProps } from './types';

const Design: React.FC<React.PropsWithChildren<DesignProps>> & DesignComposition = (props) => {
  const { children, contentName, currentCoverUrl, ...rest } = props;

  const [overlayContent, setOverlayContent] = useState<{ type: DesignCard }>({
    type: DesignCard.None,
  });
  const [previewCover, setPreviewCover] = useState<CoverType>({ url: '', name: '' });

  useEffect(() => {
    setPreviewCover({
      url: currentCoverUrl ?? '',
      name: contentName,
    });
  }, [contentName, currentCoverUrl]);

  return (
    <DesignContextProvider
      contentName={contentName}
      currentCoverUrl={currentCoverUrl}
      overlayContent={overlayContent}
      previewCover={previewCover}
      setOverlayContent={setOverlayContent}
      setPreviewCover={setPreviewCover}
      {...rest}>
      {children}
    </DesignContextProvider>
  );
};

Design.Sidebar = Sidebar;
Design.SidebarOverlay = SidebarOverlay;
Design.Preview = Preview;

export default Design;
